import { useSnackbar } from 'notistack';
import { IS_DEV_MODE } from '../logging';
import { TranslationAdapter } from '../translation';
import { INotificationService } from './interfaces';
import { NotificationType } from './models';

const { VITE_APP_NAME } = import.meta.env;

const PROD_STYLING = {
  style: { top: `${window.innerHeight / 2 - 100}px` },
  anchorOrigin: { vertical: 'top', horizontal: 'center' },
} as const;

const shouldUseDevStyling = VITE_APP_NAME === 'wu-dot-com' || IS_DEV_MODE;

export const notify = () => {
  const { enqueueSnackbar } = useSnackbar();

  return (message: string, type: NotificationType = 'success') => {
    enqueueSnackbar(message, { variant: type });
  };
};

export const translateAndNotifyError = () => {
  const { unsafeT } = TranslationAdapter();
  const { enqueueSnackbar } = useSnackbar();

  if (shouldUseDevStyling) {
    return (message: string) => {
      enqueueSnackbar(unsafeT(message), { variant: 'error' });
    };
  }

  return (message: string) => {
    enqueueSnackbar(unsafeT(message), { variant: 'error', ...PROD_STYLING });
  };
};

export const translateAndNotifySuccess = () => {
  const { unsafeT } = TranslationAdapter();
  const { enqueueSnackbar } = useSnackbar();

  if (shouldUseDevStyling) {
    return (message: string) => {
      enqueueSnackbar(unsafeT(message), { variant: 'success' });
    };
  }

  return (message: string) => {
    enqueueSnackbar(unsafeT(message), { variant: 'success', ...PROD_STYLING });
  };
};

export const NotificationsService = (): INotificationService => {
  return {
    notify: notify(),
    translateAndNotifyError: translateAndNotifyError(),
    translateAndNotifySuccess: translateAndNotifySuccess(),
  };
};
